export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: any;
  /** Generic Object */
  Object: any;
};

export type ApprovalEntity = {
  __typename?: 'ApprovalEntity';
  allowedDiscount?: Maybe<Scalars['Int']>;
  allowedTrialDays?: Maybe<Scalars['Int']>;
  approvalRequired?: Maybe<Scalars['Boolean']>;
  approverGroup?: Maybe<Scalars['String']>;
  currentTotalTrialLength?: Maybe<Scalars['Int']>;
  discountPercentage?: Maybe<Scalars['Int']>;
  discountValue?: Maybe<Scalars['Float']>;
  edition?: Maybe<Scalars['String']>;
  entityId: Scalars['String'];
  entityNumber?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  netTrialDays?: Maybe<Scalars['Int']>;
  noOfDays?: Maybe<Scalars['Int']>;
  productName?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  refundType?: Maybe<Scalars['String']>;
  slackChannel?: Maybe<Scalars['String']>;
  ssamContainer?: Maybe<Scalars['String']>;
  standardTrialLength?: Maybe<Scalars['Int']>;
  trialExtensionDaysRequested?: Maybe<Scalars['Int']>;
};

export type ApprovalEntityInput = {
  cloudSiteName?: Maybe<Scalars['String']>;
  cloudSiteUrl?: Maybe<Scalars['String']>;
  currentTotalQuoteExtensionLength?: Maybe<Scalars['Int']>;
  currentTotalTrialLength?: Maybe<Scalars['Int']>;
  discountPercentage?: Maybe<Scalars['Int']>;
  discountValue?: Maybe<Scalars['Float']>;
  edition?: Maybe<Scalars['String']>;
  entityId: Scalars['String'];
  entityNumber?: Maybe<Scalars['String']>;
  entityType: Scalars['String'];
  fromPricingPlanKey?: Maybe<Scalars['String']>;
  isApp?: Maybe<Scalars['Boolean']>;
  netQuoteExtensionDays?: Maybe<Scalars['Int']>;
  netTrialDays?: Maybe<Scalars['Int']>;
  noOfDays?: Maybe<Scalars['Int']>;
  principals?: Maybe<Array<Maybe<Scalars['String']>>>;
  productName?: Maybe<Scalars['String']>;
  quoteExtensionDaysRequested?: Maybe<Scalars['Int']>;
  quoteStatus?: Maybe<Scalars['String']>;
  refundType?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  standardQuoteExtensionLength?: Maybe<Scalars['Int']>;
  standardTrialLength?: Maybe<Scalars['Int']>;
  toPricingPlanKey?: Maybe<Scalars['String']>;
  trialExtensionDaysRequested?: Maybe<Scalars['Int']>;
};

export enum ApprovalStatus {
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  IN_REVIEW = 'IN_REVIEW',
  REASONS_PROVIDED = 'REASONS_PROVIDED',
  REASONS_REQUESTED = 'REASONS_REQUESTED',
  REQUEST_CANCELED = 'REQUEST_CANCELED',
  WAITING_FOR_REVIEW = 'WAITING_FOR_REVIEW',
}

export enum ApprovalType {
  CLOUD_SITE_DELETION = 'CLOUD_SITE_DELETION',
  ORDER_DISCOUNT = 'ORDER_DISCOUNT',
  PRICING_PLAN_CHANGE = 'PRICING_PLAN_CHANGE',
  PRODUCT_DELETION = 'PRODUCT_DELETION',
  QUOTE_DISCOUNT = 'QUOTE_DISCOUNT',
  QUOTE_EXTENSION = 'QUOTE_EXTENSION',
  SUBSCRIPTION_REFUND = 'SUBSCRIPTION_REFUND',
  TAX_REFUND = 'TAX_REFUND',
  TRIAL_EXTENSION = 'TRIAL_EXTENSION',
}

export type AssignTaskInput = {
  assignee?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  taskId: Scalars['ID'];
};

export type AssignTaskPayload = {
  __typename?: 'AssignTaskPayload';
  status: UpdateStatus;
};

export type AuditTrail = {
  __typename?: 'AuditTrail';
  actor?: Maybe<Scalars['String']>;
  comments?: Maybe<Scalars['String']>;
  context?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['String']>;
};

export type AuditTrailTask = {
  __typename?: 'AuditTrailTask';
  taskAuditTrail?: Maybe<Array<Maybe<AuditTrail>>>;
  taskId?: Maybe<Scalars['String']>;
  taskName?: Maybe<Scalars['String']>;
};

export type AuditTrailTaskList = {
  __typename?: 'AuditTrailTaskList';
  tasks?: Maybe<Array<Maybe<AuditTrailTask>>>;
};

export type BulkTaskList = {
  __typename?: 'BulkTaskList';
  errorMessage?: Maybe<Scalars['String']>;
  taskId?: Maybe<Scalars['String']>;
  updated?: Maybe<Scalars['Boolean']>;
};

export type BulkTaskUpdateInput = {
  approvalStatus?: Maybe<ApprovalStatus>;
  comment?: Maybe<Scalars['String']>;
  taskIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type BulkTaskUpdatePayload = {
  __typename?: 'BulkTaskUpdatePayload';
  status?: Maybe<UpdateStatus>;
  taskList?: Maybe<Array<Maybe<BulkTaskList>>>;
};

export type CancelRequestInput = {
  businessKey?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  processInstanceId?: Maybe<Scalars['String']>;
};

export type ChangeAssigneeInput = {
  assignee?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  requestType?: Maybe<Scalars['String']>;
  taskIdList?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type Comment = {
  __typename?: 'Comment';
  id?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  taskId?: Maybe<Scalars['String']>;
  time?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/**
 * The connection model provides a standard mechanism for slicing and paginating the result set.
 *
 * See [Relay docs](https://relay.dev/graphql/connections.htm)
 */
export type Connection = {
  pageInfo?: Maybe<PageInfo>;
  totalCount?: Maybe<Scalars['Int']>;
};

/** Common parameters when searching for a connection and paginating (either by cursor or offset). Uses Hydra terminology by default. */
export type ConnectionSearchOptions = {
  after?: Maybe<Scalars['String']>;
  cursor?: Maybe<Scalars['ID']>;
  first?: Maybe<Scalars['Int']>;
  offset?: Maybe<Scalars['Int']>;
  sort?: Maybe<SortType>;
};

export type DecisionChangeSummaries = {
  __typename?: 'DecisionChangeSummaries';
  auditId?: Maybe<Scalars['String']>;
  decisionDefinitionKey?: Maybe<Scalars['String']>;
  decisiondefinitionId?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  newValue?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedDateTime?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
};

export type DecisionDefinition = {
  __typename?: 'DecisionDefinition';
  category?: Maybe<Scalars['String']>;
  decisionRequirementsDefinitionId?: Maybe<Scalars['String']>;
  decisionRequirementsDefinitionKey?: Maybe<Scalars['String']>;
  deploymentId?: Maybe<Scalars['String']>;
  historyTimeToLive?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  resource?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  versionTag?: Maybe<Scalars['String']>;
};

export type DecisionDefinitionList = {
  __typename?: 'DecisionDefinitionList';
  decisionDefinition?: Maybe<DecisionDefinition>;
  ssamContainer?: Maybe<Scalars['String']>;
};

export type DecisionDeployment = {
  __typename?: 'DecisionDeployment';
  deployedCaseDefinitions?: Maybe<Array<Maybe<Scalars['String']>>>;
  deployedDecisionDefinitions?: Maybe<Array<Maybe<Scalars['String']>>>;
  deployedDecisionRequirementsDefinitions?: Maybe<Array<Maybe<Scalars['String']>>>;
  deployedProcessDefinitions?: Maybe<Array<Maybe<Scalars['String']>>>;
  deploymentTime?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  links?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};

/** Health of the graph by basic dependency checks */
export type DependencyHealth = {
  __typename?: 'DependencyHealth';
  key: Scalars['String'];
  label: Scalars['String'];
  successful: Scalars['Boolean'];
};

/**
 * A type that is returned in list form by a connection type’s edges field is considered by this spec to be an Edge Type. Edge types must be an “Object” as defined in the “Type System” section of the GraphQL Specification.
 *
 * See [Relay docs](https://relay.dev/graphql/connections.htm#sec-Edges)
 */
export type Edge = {
  cursor?: Maybe<Scalars['ID']>;
};

export type EvaluateApprovalInput = {
  approvalType: ApprovalType;
  entityInformation?: Maybe<Array<Maybe<ApprovalEntityInput>>>;
};

export type EvaluatedEntityInformation = {
  __typename?: 'EvaluatedEntityInformation';
  approvalRequired?: Maybe<Scalars['Boolean']>;
  approverGroup?: Maybe<Scalars['String']>;
  cloudSiteName?: Maybe<Scalars['String']>;
  cloudSiteUrl?: Maybe<Scalars['String']>;
  currentTotalQuoteExtensionLength?: Maybe<Scalars['Int']>;
  currentTotalTrialLength?: Maybe<Scalars['Int']>;
  discountPercentage?: Maybe<Scalars['Int']>;
  discountValue?: Maybe<Scalars['Float']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<Scalars['String']>;
  fromPricingPlanKey?: Maybe<Scalars['String']>;
  netQuoteExtensionDays?: Maybe<Scalars['Int']>;
  netTrialDays?: Maybe<Scalars['Int']>;
  noOfDays?: Maybe<Scalars['Int']>;
  quoteExtensionDaysRequested?: Maybe<Scalars['Int']>;
  refundType?: Maybe<Scalars['String']>;
  slackChannel?: Maybe<Scalars['String']>;
  toPricingPlanKey?: Maybe<Scalars['String']>;
  trialExtensionDaysRequested?: Maybe<Scalars['Int']>;
};

export type GroupMember = {
  __typename?: 'GroupMember';
  name?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type GroupMembersInput = {
  groupName?: Maybe<Scalars['String']>;
  requestType?: Maybe<Scalars['String']>;
  staffId: Scalars['ID'];
};

export type InitiateProcessInput = {
  additionalInformation?: Maybe<Scalars['Object']>;
  approvalType?: Maybe<ApprovalType>;
  businessKey: Scalars['String'];
  entityInformation?: Maybe<Array<Maybe<ApprovalEntityInput>>>;
  gsacId?: Maybe<Scalars['String']>;
  initiatorComments?: Maybe<Scalars['String']>;
};

export type KeyValuePair = {
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type Mutation = {
  __typename?: 'Mutation';
  assignTask?: Maybe<AssignTaskPayload>;
  bulkTaskUpdate?: Maybe<BulkTaskUpdatePayload>;
  cancelRequest?: Maybe<AssignTaskPayload>;
  changeAssignee?: Maybe<AssignTaskPayload>;
  deployDecisionModel?: Maybe<DecisionDeployment>;
  evaluateApproval?: Maybe<Array<Maybe<ApprovalEntity>>>;
  initiateProcess?: Maybe<ProcessDetails>;
  unAssignTask?: Maybe<AssignTaskPayload>;
  /** Determines if the graph is currently running */
  up: Scalars['Boolean'];
  updateTask?: Maybe<UpdateTaskPayload>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type MutationAssignTaskArgs = {
  input: AssignTaskInput;
};

/** Basic typing for querying the Atlassian Business Graph */
export type MutationBulkTaskUpdateArgs = {
  id: Scalars['ID'];
  input: BulkTaskUpdateInput;
};

/** Basic typing for querying the Atlassian Business Graph */
export type MutationCancelRequestArgs = {
  input: CancelRequestInput;
};

/** Basic typing for querying the Atlassian Business Graph */
export type MutationChangeAssigneeArgs = {
  input: ChangeAssigneeInput;
};

/** Basic typing for querying the Atlassian Business Graph */
export type MutationDeployDecisionModelArgs = {
  decisionDefinitionKey?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  xml?: Maybe<Scalars['String']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type MutationEvaluateApprovalArgs = {
  input: EvaluateApprovalInput;
};

/** Basic typing for querying the Atlassian Business Graph */
export type MutationInitiateProcessArgs = {
  input: InitiateProcessInput;
};

/** Basic typing for querying the Atlassian Business Graph */
export type MutationUnAssignTaskArgs = {
  id: Scalars['ID'];
  taskId: Scalars['ID'];
};

/** Basic typing for querying the Atlassian Business Graph */
export type MutationUpdateTaskArgs = {
  input: UpdateTaskInput;
};

/**
 * Information about pagination in a connection
 *
 * See [Relay docs](https://relay.dev/graphql/connections.htm#sec-undefined.PageInfo)
 */
export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['ID']>;
  hasNextPage: Scalars['Boolean'];
};

export type ProcessDetails = {
  __typename?: 'ProcessDetails';
  processBusinessKey?: Maybe<Scalars['String']>;
  processDefinitionId?: Maybe<Scalars['String']>;
  processDefinitionKey?: Maybe<Scalars['String']>;
  processEnded?: Maybe<Scalars['Boolean']>;
  processInstanceId?: Maybe<Scalars['String']>;
  processSuspended?: Maybe<Scalars['Boolean']>;
};

export type ProcessVariables = {
  __typename?: 'ProcessVariables';
  approvalEntityResult?: Maybe<EvaluatedEntityInformation>;
  discountApprovalRequiredInPricingPlan?: Maybe<Scalars['Boolean']>;
  evaluatedEntityInformation?: Maybe<Array<Maybe<EvaluatedEntityInformation>>>;
  gsacId?: Maybe<Scalars['String']>;
  initiatorComments?: Maybe<Scalars['String']>;
  initiatorId?: Maybe<Scalars['String']>;
  initiatorName?: Maybe<Scalars['String']>;
  requestType?: Maybe<ApprovalType>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type Query = {
  __typename?: 'Query';
  auditTrailTaskList?: Maybe<AuditTrailTaskList>;
  comments?: Maybe<Array<Maybe<Comment>>>;
  decisionDefinitionList?: Maybe<Array<Maybe<DecisionDefinitionList>>>;
  decisionDefinitionModel?: Maybe<Scalars['String']>;
  /** Provides insight to if a dependency is currently accessible */
  deepcheck: Array<Maybe<DependencyHealth>>;
  groupMembers?: Maybe<Array<Maybe<GroupMember>>>;
  groupTasks?: Maybe<TaskList>;
  ruleHistory?: Maybe<RuleHistory>;
  taskActivityLog?: Maybe<Array<Maybe<TaskActivityLog>>>;
  taskDetail?: Maybe<TaskDetail>;
  taskList?: Maybe<TaskList>;
  /** Determines if the graph is currently running */
  up: Scalars['Boolean'];
  userRole?: Maybe<UserRole>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryAuditTrailTaskListArgs = {
  businessKey?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryCommentsArgs = {
  id?: Maybe<Scalars['ID']>;
  taskId?: Maybe<Scalars['ID']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryDecisionDefinitionListArgs = {
  id?: Maybe<Scalars['ID']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryDecisionDefinitionModelArgs = {
  decisionDefinitionKey?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryGroupMembersArgs = {
  input: GroupMembersInput;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryGroupTasksArgs = {
  id?: Maybe<Scalars['ID']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryRuleHistoryArgs = {
  input?: Maybe<RuleHistoryInput>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryTaskActivityLogArgs = {
  id?: Maybe<Scalars['ID']>;
  taskId?: Maybe<Scalars['ID']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryTaskDetailArgs = {
  id?: Maybe<Scalars['ID']>;
  taskId?: Maybe<Scalars['ID']>;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryTaskListArgs = {
  input: TaskListInput;
};

/** Basic typing for querying the Atlassian Business Graph */
export type QueryUserRoleArgs = {
  staffId: Scalars['ID'];
};

export type RuleHistory = {
  __typename?: 'RuleHistory';
  decisionChangeSummaries?: Maybe<Array<Maybe<DecisionChangeSummaries>>>;
  totalElements?: Maybe<Scalars['Int']>;
};

export type RuleHistoryInput = {
  decisionDefinitionKey: Scalars['String'];
  id: Scalars['ID'];
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  sortBy: Scalars['String'];
  sortOrder?: Maybe<SortOrder>;
};

/** Direction to sort returned connection */
export enum SortDirection {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum SortOrder {
  ASC = 'ASC',
  DESC = 'DESC',
}

/** ElasticSearch Script for finely tuned sorts (used with Hydra) */
export type SortScript = {
  order?: Maybe<Scalars['String']>;
  returnType?: Maybe<Scalars['String']>;
  script?: Maybe<Scalars['String']>;
};

/** Available sort options; defaults to Hydra terminology */
export type SortType = {
  /** Fields to sort, must be equal length to sortFieldsDirections */
  sortFields?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Direction to sort, must be equal length to sortFields */
  sortFieldsDirections?: Maybe<Array<Maybe<SortDirection>>>;
  sortScript?: Maybe<Array<Maybe<SortScript>>>;
};

export type Task = {
  __typename?: 'Task';
  approvalStatus?: Maybe<ApprovalStatus>;
  assigneeId?: Maybe<Scalars['String']>;
  assigneeName?: Maybe<Scalars['String']>;
  businessKey?: Maybe<Scalars['String']>;
  createdDate?: Maybe<Scalars['String']>;
  discountApprovalRequiredInPricingPlan?: Maybe<Scalars['Boolean']>;
  discountValue?: Maybe<Scalars['Float']>;
  dueDate?: Maybe<Scalars['String']>;
  endDate?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  gsacId?: Maybe<Scalars['String']>;
  initiatorId?: Maybe<Scalars['String']>;
  initiatorName?: Maybe<Scalars['String']>;
  ownerId?: Maybe<Scalars['String']>;
  ownerName?: Maybe<Scalars['String']>;
  processDefinitionId?: Maybe<Scalars['String']>;
  processDefinitionKey?: Maybe<Scalars['String']>;
  processDefinitionName?: Maybe<Scalars['String']>;
  processInstanceId?: Maybe<Scalars['String']>;
  requestType?: Maybe<ApprovalType>;
  slackChannel?: Maybe<Scalars['String']>;
  slackMessageUrl?: Maybe<Scalars['String']>;
  taskId: Scalars['ID'];
  taskName?: Maybe<Scalars['String']>;
  taskNumber?: Maybe<Scalars['String']>;
};

export type TaskActivityLog = {
  __typename?: 'TaskActivityLog';
  taskAuditTrail?: Maybe<Array<Maybe<TaskAuditTrail>>>;
  taskId: Scalars['String'];
  taskName: Scalars['String'];
  taskNumber: Scalars['String'];
  taskStatus: ApprovalStatus;
};

export type TaskAuditTrail = {
  __typename?: 'TaskAuditTrail';
  actor?: Maybe<Scalars['String']>;
  context?: Maybe<TaskAuditTrailContext>;
  time?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export enum TaskAuditTrailContext {
  COMMENT = 'COMMENT',
  INITIATED = 'INITIATED',
  STATUS_CHANGE = 'STATUS_CHANGE',
}

export type TaskDetail = {
  __typename?: 'TaskDetail';
  assigneeName?: Maybe<Scalars['String']>;
  businessKey?: Maybe<Scalars['String']>;
  ownerName?: Maybe<Scalars['String']>;
  processVariables?: Maybe<ProcessVariables>;
  taskProperties?: Maybe<TaskProperties>;
  taskVariables?: Maybe<TaskVariables>;
};

export type TaskList = {
  __typename?: 'TaskList';
  tasks?: Maybe<Array<Task>>;
  userRole?: Maybe<UserRole>;
};

export type TaskListInput = {
  approvalType?: Maybe<ApprovalType>;
  businessKey?: Maybe<Scalars['String']>;
  staffId: Scalars['ID'];
  taskStatus?: Maybe<TaskStatus>;
  taskType: TaskType;
};

export type TaskProperties = {
  __typename?: 'TaskProperties';
  assignee?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  processDefinitionId?: Maybe<Scalars['String']>;
  processInstanceId?: Maybe<Scalars['String']>;
  taskDefinitionKey?: Maybe<Scalars['String']>;
};

export enum TaskStatus {
  Completed = 'Completed',
  Open = 'Open',
}

export enum TaskType {
  AllTasks = 'AllTasks',
  MyGroupTasks = 'MyGroupTasks',
  MyTasks = 'MyTasks',
}

export type TaskVariables = {
  __typename?: 'TaskVariables';
  approvalStatus?: Maybe<ApprovalStatus>;
  slackMessageUrl?: Maybe<Scalars['String']>;
  taskNumber?: Maybe<Scalars['String']>;
};

export enum UpdateStatus {
  ERROR = 'ERROR',
  OK = 'OK',
}

export type UpdateTaskInput = {
  approvalStatus?: Maybe<ApprovalStatus>;
  comment?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  taskId: Scalars['ID'];
};

export type UpdateTaskPayload = {
  __typename?: 'UpdateTaskPayload';
  status: UpdateStatus;
};

export enum UserRole {
  ADVOCATE = 'ADVOCATE',
  APPROVER = 'APPROVER',
  SUPERUSER = 'SUPERUSER',
}

export type DecisionDefinitionModelQueryVariables = Exact<{
  id: Scalars['ID'];
  decisionDefinitionKey: Scalars['String'];
}>;

export type DecisionDefinitionModelQuery = { __typename?: 'Query' } & Pick<Query, 'decisionDefinitionModel'>;

export type RuleHistoryQueryVariables = Exact<{
  id: Scalars['ID'];
  decisionDefinitionKey: Scalars['String'];
  pageNumber: Scalars['Int'];
  pageSize: Scalars['Int'];
  sortBy: Scalars['String'];
  sortOrder: SortOrder;
}>;

export type RuleHistoryQuery = { __typename?: 'Query' } & {
  ruleHistory?: Maybe<
    { __typename?: 'RuleHistory' } & Pick<RuleHistory, 'totalElements'> & {
        decisionChangeSummaries?: Maybe<
          Array<
            Maybe<
              { __typename?: 'DecisionChangeSummaries' } & Pick<
                DecisionChangeSummaries,
                | 'auditId'
                | 'decisiondefinitionId'
                | 'decisionDefinitionKey'
                | 'version'
                | 'oldValue'
                | 'newValue'
                | 'message'
                | 'updatedBy'
                | 'updatedDateTime'
                | 'fullName'
              >
            >
          >
        >;
      }
  >;
};

export type DecisionDefinitionListQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type DecisionDefinitionListQuery = { __typename?: 'Query' } & {
  decisionDefinitionList?: Maybe<
    Array<
      Maybe<
        { __typename?: 'DecisionDefinitionList' } & Pick<DecisionDefinitionList, 'ssamContainer'> & {
            decisionDefinition?: Maybe<
              { __typename?: 'DecisionDefinition' } & Pick<DecisionDefinition, 'id' | 'key' | 'name'>
            >;
          }
      >
    >
  >;
};

export type DeployDecisionModelMutationVariables = Exact<{
  id: Scalars['ID'];
  decisionDefinitionKey: Scalars['String'];
  xml?: Maybe<Scalars['String']>;
}>;

export type DeployDecisionModelMutation = { __typename?: 'Mutation' } & {
  deployDecisionModel?: Maybe<{ __typename?: 'DecisionDeployment' } & Pick<DecisionDeployment, 'id' | 'name'>>;
};

export type EvaluateApprovalMutationVariables = Exact<{
  approvalType: ApprovalType;
  entityInformation?: Maybe<Array<Maybe<ApprovalEntityInput>> | Maybe<ApprovalEntityInput>>;
}>;

export type EvaluateApprovalMutation = { __typename?: 'Mutation' } & {
  evaluateApproval?: Maybe<
    Array<
      Maybe<
        { __typename?: 'ApprovalEntity' } & Pick<
          ApprovalEntity,
          | 'entityId'
          | 'entityNumber'
          | 'entityType'
          | 'noOfDays'
          | 'refundType'
          | 'currentTotalTrialLength'
          | 'trialExtensionDaysRequested'
          | 'standardTrialLength'
          | 'netTrialDays'
          | 'productName'
          | 'edition'
          | 'approvalRequired'
          | 'slackChannel'
          | 'reason'
        >
      >
    >
  >;
};

export type InitiateProcessMutationVariables = Exact<{
  approvalType: ApprovalType;
  businessKey: Scalars['String'];
  initiatorComments: Scalars['String'];
  gsacId: Scalars['String'];
  entityInformation?: Maybe<Array<Maybe<ApprovalEntityInput>> | Maybe<ApprovalEntityInput>>;
  additionalInformation?: Maybe<Scalars['Object']>;
}>;

export type InitiateProcessMutation = { __typename?: 'Mutation' } & {
  initiateProcess?: Maybe<{ __typename?: 'ProcessDetails' } & Pick<ProcessDetails, 'processDefinitionId'>>;
};

export type TaskFieldsFragment = { __typename?: 'Task' } & Pick<
  Task,
  | 'taskId'
  | 'taskName'
  | 'createdDate'
  | 'dueDate'
  | 'initiatorName'
  | 'assigneeName'
  | 'processDefinitionKey'
  | 'approvalStatus'
  | 'ownerId'
  | 'ownerName'
  | 'processDefinitionName'
  | 'taskNumber'
  | 'assigneeId'
  | 'initiatorId'
  | 'processInstanceId'
  | 'requestType'
  | 'groupId'
  | 'businessKey'
  | 'endDate'
  | 'slackChannel'
  | 'gsacId'
  | 'entityType'
  | 'slackMessageUrl'
  | 'entityId'
  | 'discountApprovalRequiredInPricingPlan'
  | 'discountValue'
>;

export type FetchTaskListQueryVariables = Exact<{
  staffId: Scalars['ID'];
  taskType: TaskType;
  taskStatus?: Maybe<TaskStatus>;
  businessKey?: Maybe<Scalars['String']>;
  approvalType?: Maybe<ApprovalType>;
}>;

export type FetchTaskListQuery = { __typename?: 'Query' } & {
  taskList?: Maybe<
    { __typename?: 'TaskList' } & Pick<TaskList, 'userRole'> & {
        tasks?: Maybe<Array<{ __typename?: 'Task' } & TaskFieldsFragment>>;
      }
  >;
};

export type FetchGroupMembersQueryVariables = Exact<{
  staffId: Scalars['ID'];
  groupName?: Maybe<Scalars['String']>;
  requestType?: Maybe<Scalars['String']>;
}>;

export type FetchGroupMembersQuery = { __typename?: 'Query' } & {
  groupMembers?: Maybe<Array<Maybe<{ __typename?: 'GroupMember' } & Pick<GroupMember, 'userId' | 'name'>>>>;
};

export type FetchTaskCommentsQueryVariables = Exact<{
  taskId: Scalars['ID'];
  id: Scalars['ID'];
}>;

export type FetchTaskCommentsQuery = { __typename?: 'Query' } & {
  comments?: Maybe<Array<Maybe<{ __typename?: 'Comment' } & Pick<Comment, 'id' | 'userId' | 'message' | 'time'>>>>;
};

export type TaskDetailEvaluatedEntityInformationFragment = { __typename?: 'EvaluatedEntityInformation' } & Pick<
  EvaluatedEntityInformation,
  | 'entityId'
  | 'entityType'
  | 'noOfDays'
  | 'refundType'
  | 'approvalRequired'
  | 'slackChannel'
  | 'approverGroup'
  | 'currentTotalTrialLength'
  | 'trialExtensionDaysRequested'
  | 'netTrialDays'
  | 'currentTotalQuoteExtensionLength'
  | 'quoteExtensionDaysRequested'
  | 'netQuoteExtensionDays'
  | 'discountValue'
  | 'discountPercentage'
  | 'toPricingPlanKey'
  | 'fromPricingPlanKey'
  | 'cloudSiteName'
  | 'cloudSiteUrl'
>;

export type FetchUserRoleQueryVariables = Exact<{
  id: Scalars['ID'];
}>;

export type FetchUserRoleQuery = { __typename?: 'Query' } & Pick<Query, 'userRole'>;

export type FetchTaskDetailQueryVariables = Exact<{
  taskId: Scalars['ID'];
  id: Scalars['ID'];
}>;

export type FetchTaskDetailQuery = { __typename?: 'Query' } & Pick<Query, 'userRole'> & {
    taskDetail?: Maybe<
      { __typename?: 'TaskDetail' } & Pick<TaskDetail, 'businessKey' | 'assigneeName' | 'ownerName'> & {
          taskProperties?: Maybe<
            { __typename?: 'TaskProperties' } & Pick<
              TaskProperties,
              | 'id'
              | 'name'
              | 'assignee'
              | 'created'
              | 'owner'
              | 'processDefinitionId'
              | 'processInstanceId'
              | 'taskDefinitionKey'
            >
          >;
          taskVariables?: Maybe<
            { __typename?: 'TaskVariables' } & Pick<TaskVariables, 'approvalStatus' | 'taskNumber' | 'slackMessageUrl'>
          >;
          processVariables?: Maybe<
            { __typename?: 'ProcessVariables' } & Pick<
              ProcessVariables,
              | 'initiatorName'
              | 'initiatorId'
              | 'initiatorComments'
              | 'requestType'
              | 'gsacId'
              | 'discountApprovalRequiredInPricingPlan'
            > & {
                evaluatedEntityInformation?: Maybe<
                  Array<
                    Maybe<{ __typename?: 'EvaluatedEntityInformation' } & TaskDetailEvaluatedEntityInformationFragment>
                  >
                >;
                approvalEntityResult?: Maybe<
                  { __typename?: 'EvaluatedEntityInformation' } & TaskDetailEvaluatedEntityInformationFragment
                >;
              }
          >;
        }
    >;
  };

export type FetchTaskActivityLogQueryVariables = Exact<{
  taskId: Scalars['ID'];
  id: Scalars['ID'];
}>;

export type FetchTaskActivityLogQuery = { __typename?: 'Query' } & {
  taskActivityLog?: Maybe<
    Array<
      Maybe<
        { __typename?: 'TaskActivityLog' } & Pick<
          TaskActivityLog,
          'taskName' | 'taskId' | 'taskNumber' | 'taskStatus'
        > & {
            taskAuditTrail?: Maybe<
              Array<
                Maybe<{ __typename?: 'TaskAuditTrail' } & Pick<TaskAuditTrail, 'time' | 'context' | 'actor' | 'value'>>
              >
            >;
          }
      >
    >
  >;
};

export type UpdateTaskMutationVariables = Exact<{
  taskId: Scalars['ID'];
  approvalStatus?: Maybe<ApprovalStatus>;
  comment?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
}>;

export type UpdateTaskMutation = { __typename?: 'Mutation' } & {
  updateTask?: Maybe<{ __typename?: 'UpdateTaskPayload' } & Pick<UpdateTaskPayload, 'status'>>;
};

export type FetchAuditTrailListQueryVariables = Exact<{
  id: Scalars['ID'];
  businessKey?: Maybe<Scalars['String']>;
}>;

export type FetchAuditTrailListQuery = { __typename?: 'Query' } & {
  auditTrailTaskList?: Maybe<
    { __typename?: 'AuditTrailTaskList' } & {
      tasks?: Maybe<
        Array<
          Maybe<
            { __typename?: 'AuditTrailTask' } & Pick<AuditTrailTask, 'taskName' | 'taskId'> & {
                taskAuditTrail?: Maybe<
                  Array<
                    Maybe<{ __typename?: 'AuditTrail' } & Pick<AuditTrail, 'time' | 'context' | 'actor' | 'comments'>>
                  >
                >;
              }
          >
        >
      >;
    }
  >;
};

export type AssignTaskMutationVariables = Exact<{
  taskId: Scalars['ID'];
  assignee?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
}>;

export type AssignTaskMutation = { __typename?: 'Mutation' } & {
  assignTask?: Maybe<{ __typename?: 'AssignTaskPayload' } & Pick<AssignTaskPayload, 'status'>>;
};

export type UnAssignTaskMutationVariables = Exact<{
  taskId: Scalars['ID'];
  id: Scalars['ID'];
}>;

export type UnAssignTaskMutation = { __typename?: 'Mutation' } & {
  unAssignTask?: Maybe<{ __typename?: 'AssignTaskPayload' } & Pick<AssignTaskPayload, 'status'>>;
};

export type CancelRequestMutationVariables = Exact<{
  processInstanceId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  businessKey?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['String']>;
}>;

export type CancelRequestMutation = { __typename?: 'Mutation' } & {
  cancelRequest?: Maybe<{ __typename?: 'AssignTaskPayload' } & Pick<AssignTaskPayload, 'status'>>;
};

export type ChangeAssigneeMutationVariables = Exact<{
  assignee?: Maybe<Scalars['String']>;
  groupName?: Maybe<Scalars['String']>;
  requestType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  taskIdList?: Maybe<Array<Maybe<Scalars['String']>> | Maybe<Scalars['String']>>;
}>;

export type ChangeAssigneeMutation = { __typename?: 'Mutation' } & {
  changeAssignee?: Maybe<{ __typename?: 'AssignTaskPayload' } & Pick<AssignTaskPayload, 'status'>>;
};

export type BulkTaskUpdateMutationVariables = Exact<{
  input: BulkTaskUpdateInput;
  id: Scalars['ID'];
}>;

export type BulkTaskUpdateMutation = { __typename?: 'Mutation' } & {
  bulkTaskUpdate?: Maybe<
    { __typename?: 'BulkTaskUpdatePayload' } & Pick<BulkTaskUpdatePayload, 'status'> & {
        taskList?: Maybe<
          Array<Maybe<{ __typename?: 'BulkTaskList' } & Pick<BulkTaskList, 'taskId' | 'updated' | 'errorMessage'>>>
        >;
      }
  >;
};
